/* eslint-disable no-console */
/* eslint-disable no-undef */
export const apiResponseErrors = {
    noAffiliate: `Widget Error: No Affiliate Id provided. Falling back to default Destination ID.`,
    wrongAffiliate: `Widget Error: Affiliate Code provided does not exist in the affiliate API. Falling back to using default Affiliate Code.`,
    wrongSubAffiliate: `Widget Error: Sub Affiliate Code provided does not exist in the affiliate API. Falling back to using ONLY Affiliate Code.`,
    issueWithAPI: `Widget Error: There was an issue with the Affiliate API.`,
};

export const logAffiliateError = (error, subAssociateCode) => {
    console.error(
        error.status >= 500
            ? `${error.status}: ${apiResponseErrors.issueWithAPI}`
            : subAssociateCode
            ? `${error.status}: ${apiResponseErrors.wrongSubAffiliate}`
            : `${error.status}: ${apiResponseErrors.wrongAffiliate}`
    );
};
